import AdminApi from "@/api/admin/AdminApi";

const state = {
  accessToken: sessionStorage.getItem("AdminAccessToken") || null,
  isLoggedIn: false,
  userStatus: 'ADMIN',
  username: null,
  email: null,
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  SET_LOGIN_STATUS(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  },
  setUserStatus(state, status) {
    state.userStatus = status;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setEmail(state, email) {
    state.email = email;
  }
};

const actions = {
  async login({ commit }, { email, password }) {
    return AdminApi.loginApi(email, password).then(data => {
      sessionStorage.setItem("AdminAccessToken", data.access_token);
      commit('setAccessToken', data.access_token);
      commit('SET_LOGIN_STATUS', true);
      return data;
    }).catch(error => {
      console.error('Login error:', error);
      throw error;
    });
  },

  async logout({ commit }) {
    return AdminApi.logoutApi().then(() => {
      sessionStorage.removeItem("AdminAccessToken");
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUsername', null);
      commit('setEmail', null);
    }).catch(error => {
      console.error('Logout error:', error);
      throw error;
    });
  },
  checkAuth({ commit, state }) {
    const token = sessionStorage.getItem("AdminAccessToken");
    if (token) {
      if (!state.isLoggedIn) {
        commit('setAccessToken', token);
        commit('SET_LOGIN_STATUS', true);
        // dispatch('naviList/list', null, { root: true });
      }
    } else if (state.isLoggedIn) {
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUserStatus', 'guest');
    }
  },
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userStatus: state => state.userStatus,
  username: state => state.username,
  email: state => state.email,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
